// Keys claimed by window-level list navigation (useKeyHandler/useKeyboardNav).
// Shared so any component with its own keydown handler can check "is this a nav key"
// without re-typing the list and risking drift.
export const NAV_KEYS = ['w', 's', 'W', 'S', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'a', 'A', 'Escape'];
